import { createApp } from 'vue'
import FArticleFilter from '~/js/components/articleFilter'
import FLinkCard from '~/js/components/linkCard'
import { LinkItem } from '~/js/models/linkItem'

const ID = 'js-blogFeature'

document.addEventListener('DOMContentLoaded', () => {
  const elementBlogFeature = document.getElementById(ID)
  if (!elementBlogFeature) return

  const { articleCount, blogHandle } = elementBlogFeature.dataset
  const baseUrl = `/blogs/${blogHandle}`

  const linkItems = JSON.parse(elementBlogFeature.dataset.linkItems)
    .slice(0, Number(articleCount))
    .map((linkItem) => {
      const url = `${baseUrl}/${linkItem.handle}`
      return new LinkItem(linkItem, url)
    })
  createApp({
    name: 'TemplatesBlogFeature',
    data() {
      return {
        baseUrl,
        linkItems,
      }
    },
    components: {
      FArticleFilter,
      FLinkCard,
    },
  }).mount(elementBlogFeature)
})
